module.exports = __webpack_public_path__ + "img/xpu-ha-room.dbe3846e.jpg";